import { gql } from "@apollo/client";

const UPDATE_CATEGORY_POINTS = gql`
  mutation updateRankingCategoryPoint(
    $id: Int!
    $place: String!
    $points: Float!
    $numPlaces: Int!
    $segment: String
    $bracketType: String
  ) {
    updateRankingCategoryPoints(
      updateRankingCategoryPointsInput: {
        id: $id
        place: $place
        points: $points
        numPlaces: $numPlaces
        bracketType: $bracketType
        segment: $segment
      }
    ) {
      id
    }
  }
`;

export default UPDATE_CATEGORY_POINTS;
